:host {
  display: block;
}

.radio-label {
  color: var(--theme-primary-color);
  text-align: right;
  align-items: center;
  gap: 0.5rem;
  margin-right: 1rem;
}

.field-container {
  display: grid;
  grid-template-columns: 10em 1fr 20px;
  align-items: center;
  gap: 1rem;
}

.custom-label {
  color: var(--theme-primary-color);
  text-align: right;
  align-items: center;
  font-weight: bold;
  gap: 0.5rem;
}

.radio-input {
  margin-right: 0.2rem;
}
